/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/3 11:05 上午
*/
export default {
    token: null,
    userInfo: {},
    isStore: true,    // 用户是否是商家类型
    projectConfig: {},   // 项目品牌信息
}



// WEBPACK FOOTER //
// ./src/store/state/index.js